import React, { useRef, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Logo, login, card } from "../../assets/img";

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const menuRefs = useRef([]);
  const barRef = useRef(null);

  const menu = [
    { label: "Home", path: "/home" },
    { label: "Lotteries", path: "/lottery" },
    { label: "Results", path: "/result" },
    { label: "Winners", path: "/customer-winner" },
  ];

  useEffect(() => {
    const index = menu.findIndex((m) => m.path === location.pathname);
    const element = menuRefs.current[index];

    if (element && barRef.current) {
      const { offsetLeft, offsetWidth } = element;

      barRef.current.style.width = `${offsetWidth - 1}px`;
      barRef.current.style.transform = `translateX(${offsetLeft + 1}px)`;
    }
  }, [location.pathname]);

  return (
    <header className="unique-header">
      <div className="header-wrapper">

        {/* LOGO */}
        <div className="logo-box">
          <img src={Logo} alt="logo" />
        </div>

        {/* NAVIGATION */}
        <div className="nav-container">
          <div ref={barRef} className="active-bar" />

          {menu.map((item, i) => (
            <span
              key={item.path}
              className="nav-item"
              ref={(el) => (menuRefs.current[i] = el)}
              onClick={() => navigate(item.path)}
            >
              {item.label}
            </span>
          ))}
        </div>

        {/* BUTTONS */}
        <div className="button-set"  onClick={() => navigate("/")}>
          <button className="action-btn">Login</button>
          <img src={login} className="header-icon" />
        </div>
        <div onClick={() => navigate("/card")}>

          <button className="action-btn">Card</button>
          <img src={card} className="header-icon" />
        </div>
      </div>
    </header>
  );
};

export default Header;
